var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-08-01
 * @brief SEI 에너지Report 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { alertState, curConsultingState, curReportState, curTotalState, mainState } from "@recoil/assessmentState";
import { loadingBoxState } from "@recoil/menuState";
import { reLoadState, reloadSpg, userInfoLoginState } from "@recoil/userState";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// utils
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
import * as FILEUTILS from "@utils/file/fileUtil";
import EhpPagination from "../../common/pagination/EhpPagination";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
// 압축 다운로드
import ReportBasketsPop from "@components/dashBoard/report/ReportBasketsPop";
import { langId, langState } from "@recoil/langState";
import { useTrans } from "@utils/langs/useTrans";
import axios from "axios";
import JSZip from "jszip";
function ReportEnergy(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTreeTotal = useRecoilValue(curTotalState);
    const langs = useRecoilValue(langState);
    const langIds = useRecoilValue(langId);
    const setReloadState = useSetRecoilState(reLoadState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reloadspg, setReloadspg] = useRecoilState(reloadSpg);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curConsultingState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const [repop, setRepop] = useState(false);
    //props
    const { handleOpenPop, isMobile, treeSel, setWork, basketsItem, setBasketsItem, setSuccess } = props;
    const [toogle, setToogle] = useState(false);
    const [treeItem, setTreeItem] = useState([]);
    const [reportItem, setReportItem] = useState([]);
    const [averageToogle, setAverageToogle] = useState(false);
    const types = [
        { code: "monthly", name: t("라벨.월간") },
        { code: "quarterly", name: t("라벨.분기") },
        { code: "yearly", name: t("라벨.연간") },
    ];
    const [type, setType] = useState(types[0]);
    const [curTree, setCurTree] = useState(null);
    // 페이징
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 검색
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState("");
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "updatedTime",
        sort: "desc",
    });
    const dateTermList = [
        { id: 0, dtDisp: t("라벨.직접입력"), dateFormats: "null", dtVal: 0 },
        { id: 1, dtDisp: t("라벨.T_월", ["1"]), dateFormats: "month", dtVal: 1 },
        { id: 2, dtDisp: t("라벨.T_월", ["3"]), dateFormats: "month", dtVal: 3 },
        { id: 3, dtDisp: t("라벨.T_월", ["6"]), dateFormats: "month", dtVal: 6 },
        { id: 4, dtDisp: t("라벨.T_년", ["1"]), dateFormats: "year", dtVal: 1 },
    ];
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateSel, setDateSel] = useState(null);
    const [searchCount, setSearchCount] = useState({
        startDate: null,
        endDate: null,
    });
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    const [changeTree, setChangeTree] = useState(null);
    useEffect(() => {
        //report
        handleOpenPop("pop-report", _jsx(ReportBasketsPop, { basketsItem: basketsItem, setBasketsItem: setBasketsItem, setWork: setWork }));
        //검색
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
        //공유
        handleOpenPop("pop-share", _jsx(SharePop, { checkItem: checkItem, repop: repop, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => PopClose("pop-share") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { checkItem: checkItem, setCheckItem: setCheckItem, setCheckArr: setCheckArr, handleCurPage: handleCurPage }));
    }, [basketsItem, searchText, checkItem, repop]);
    //  닫기
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setRepop(true);
    }
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/zone/filter`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds.toString() + reloadspg,
    });
    useEffect(() => {
        setChangeTree(recoilTreeData);
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (!recoilTreeData.companyId) {
                    let treeItem = data.body;
                    let curComapy = treeItem.filter((item) => item.zoneId == recoilState.zoneId).length > 0
                        ? treeItem.filter((item) => item.zoneId == recoilState.zoneId)[0]
                        : treeItem.filter((item) => item.companyId == recoilTreeTotal.companyId).length > 0
                            ? treeItem.filter((item) => item.companyId == recoilTreeTotal.companyId)[0]
                            : treeItem[0];
                    setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { companyId: curComapy.companyId, name: curComapy.name, zoneId: curComapy.zoneId }));
                    setRecoilState({
                        companyId: curComapy.companyId,
                        zoneId: curComapy.zoneId,
                    });
                }
                setTreeItem(data.body);
                if (reloadspg) {
                    handleCurPage(0);
                    setSortData({
                        sortField: "updatedTime",
                        sort: "desc",
                    });
                    setReloadspg(false);
                }
                // 초기화
                if (changeTree && changeTree !== recoilTreeData) {
                    const today = new Date();
                    setStartDate(dayjs(today)
                        .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                        .toDate());
                    setEndDate(today);
                    setDateSel(dateTermList[4].dtVal);
                    setSearchCount({
                        startDate: dayjs(today)
                            .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                            .toDate(),
                        endDate: today,
                    });
                    handleCurPage(0);
                    setType(types[0]);
                    setSearchText("");
                    setSearchTextField("");
                    setSortData({
                        sortField: "updatedTime",
                        sort: "desc",
                    });
                    setCheckItem([]);
                    setCheckArr([]);
                }
                setRecoilIsLoadingBox(false);
            }
            else {
                // data.body.map((err) => (err.msg));
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, searchCount, reloadspg, changeTree, langIds]);
    // 사업장
    function ZoneClick(item) {
        setRecoilTreeData({
            companyId: item.companyId,
            name: item.name,
            zoneId: item.zoneId,
        });
        setRecoilState({
            companyId: item.companyId,
            zoneId: item.zoneId,
        });
        setChangeTree(item);
        setToogle(false);
    }
    // 날짜 기간조회
    function handleDayPop(days) {
        const today = new Date();
        if (days.dateFormats == "year") {
            setStartDate(dayjs(today)
                .set("year", dayjs(today).year() - days.dtVal)
                .toDate());
            setEndDate(today);
            setSearchCount({
                startDate: dayjs(today)
                    .set("year", dayjs(today).year() - days.dtVal)
                    .toDate(),
                endDate: today,
            });
        }
        else if (days.dateFormats == "month") {
            setStartDate(dayjs(today)
                .set("month", dayjs(today).month() - days.dtVal)
                .toDate());
            setEndDate(today);
            setSearchCount({
                startDate: dayjs(today)
                    .set("month", dayjs(today).month() - days.dtVal)
                    .toDate(),
                endDate: today,
            });
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setDateSel(days.id);
        handleCurPage(0);
        setCurTree(recoilTreeData);
    }
    //조회 클릭
    function onClickSearchFilter() {
        if (!startDate && endDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "시작 일자를 입력하세요" }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else if (!endDate && startDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "종료 일자를 입력하세요" }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else {
            handleCurPage(0);
            setCurTree(recoilTreeData);
            setSearchCount({
                startDate: startDate,
                endDate: endDate,
            });
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            setSearchTextField(searchText);
        }
        else {
            CUTIL.jsopen_m_Popup(e);
        }
        handleCurPage(0);
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // PDF다운로드
    function handleZipDownload(e) {
        if (checkArr.length < 2) {
            checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
                // HTTPUTIL.fileDownload_WithPdfViewer(list.itemReportDto.serialNo, list.reportId, userInfo.loginInfo.token) // PDFView 링크이동
                HTTPUTIL.fileDownload_EhcReport(`${list.reportName}`, list.reportId, userInfo.loginInfo.token);
            }));
        }
        else {
            let zipList = [];
            let zips = new JSZip();
            let zipCnt = 0;
            const zipFileName = `${recoilTreeData.name}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
            checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
                yield getSecondFileUrl(list)
                    .then((val) => {
                    if (val.codeNum === 200) {
                        zipList = zipList.concat({
                            fileName: `${list.reportName}_${dayjs(list.updatedTime).format("HH:mm:ss")}.PDF`,
                            fileLink: val.body.fileLink,
                        });
                    }
                    return {
                        codeNum: val.codeNum,
                        fileName: `${list.reportName}_${dayjs(list.updatedTime).format("HH:mm:ss")}.PDF`,
                        fileLink: val.body.fileLink,
                    };
                })
                    .then((val) => {
                    if (val.codeNum === 200) {
                        axios({
                            method: "GET",
                            url: val.fileLink,
                            responseType: "blob",
                        })
                            .then((resp) => {
                            zips.file(val.fileName, resp.data);
                            zipCnt++;
                            return zipCnt;
                        })
                            .then((zipCnt) => {
                            if (zipCnt === checkItem.length) {
                                zips.generateAsync({ type: "blob" }).then(function (blob) {
                                    FILEUTILS.saveToFile_Chrome(zipFileName, blob); // 공유 연결시 해당 부분 변경
                                });
                            }
                        });
                    }
                });
            }));
        }
        setCheckItem([]);
        setCheckArr([]);
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function PdfBasket(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let success = [];
            let fail = [];
            let data = [];
            setRecoilIsLoadingBox(true);
            for (let i = 0; i < checkItem.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/assessment/basket`,
                    appQuery: {
                        reportType: "energyreport",
                        reportTypeId: checkItem[i].energyReportId, // energyreportId 사용
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                setReloadState(true);
                setSuccess(success);
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-report", type: CONST.TYPE_NONE, pTag: {
                        p1: success.length > 0 ? t("라벨.건을장바구니에담았습니다", [success.length.toString()]) : "",
                        p2: fail.length > 0 ? t("라벨.건은장바구니에이미담겨져있습니다", [fail.length.toString()]) : "",
                    }, callBack: () => {
                        setCheckItem([]);
                        setCheckArr([]);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        });
    }
    function MobileToogle(e) {
        if (!toogle) {
            setToogle(true);
            // CUTIL.selectFoucs("m" + recoilTreeData.zoneId);
        }
        else {
            setToogle(false);
        }
    }
    function PopReport(e) {
        if (basketsItem && basketsItem.content.length > 0) {
            CUTIL.jsopen_Popup(e);
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.1개이상의Report가필요합니다") }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    // 에너지 레포트 발행
    function EnergyPost(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/report/energyreport/pdf?zoneId=${recoilTreeData.zoneId}&type=${type.code}&reportType=${treeSel.code}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let msg = "";
                    if (data.data.data === "success") {
                        msg = t("라벨.에너지진단레포트가발행되었습니다");
                    }
                    else {
                        msg = t("라벨.에너지진단레포트발행이실패하였습니다");
                    }
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: msg, callBack: () => {
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                            setReloadspg(true);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    const zoneOpen = (e) => {
        CUTIL.onClickSelect(e, CUTIL.selectOption);
        CUTIL.selectFoucs(recoilTreeData.zoneId, { num: 0 });
    };
    // 평가 점수 토글 아웃포커싱
    useEffect(() => {
        const handleClick = (e) => {
            //e.preventDefault();
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("tooltip-link") || targetElement.closest(".tooltip-link");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".tooltip-link");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("click");
                setAverageToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    // 트리 이외 다른곳 닫기
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("select__toggleBtn") || targetElement.closest(".select__toggleBtn");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select__toggleBtn");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
                setToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsxs("div", Object.assign({ className: "box__header brd-bottom-0 gap-16" }, { children: [_jsx("div", Object.assign({ className: "m-none" }, { children: _jsxs("div", Object.assign({ className: "select", onClick: (e) => zoneOpen(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.name })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: treeItem &&
                                            treeItem.map((item, idx) => (_jsxs("li", Object.assign({ className: `option ${recoilTreeData.zoneId == item.zoneId ? "active" : ""}`, id: item.zoneId, onClick: (e) => ZoneClick(item), title: item.name }, { children: [item.name, " "] }), "userTree_" + idx.toString()))) })] })) })), _jsx("div", Object.assign({ className: `select__toggleBtn ${toogle ? "active" : ""} `, onClick: (e) => MobileToogle(e) }, { children: _jsx("p", { children: recoilTreeData.name }) })), _jsx("div", Object.assign({ className: `box selectbar menutype ${toogle ? "active" : ""}` }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: treeItem &&
                                        treeItem.map((item, idx) => (_jsx("li", Object.assign({ className: `${recoilTreeData.zoneId == item.zoneId ? "on" : ""}`, id: "m" + item.zoneId, onClick: (e) => ZoneClick(item) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: item.name }) })) }), "userTree_M" + idx.toString()))) })) })) })), _jsx("div", Object.assign({ className: "tbl__top mb-0 m-none" }, { children: _jsx("div", Object.assign({ className: "input__area" }, { children: userInfo.role == CONST.USERROLE_ADMIN && (_jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-sky", onClick: (e) => EnergyPost(e) }, { children: _jsxs("span", { children: [_jsx("p", Object.assign({ className: "txt-round" }, { children: "New" })), t("REPORT.신규리포트발행")] }) })) }))) })) }))] })), _jsxs("div", Object.assign({ className: `box__body pt-58 ${pageInfo.totalElements == 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top gap-20" }, { children: [_jsx("div", Object.assign({ className: "input__area m-block" }, { children: userInfo.role == CONST.USERROLE_ADMIN && (_jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-sky", onClick: (e) => EnergyPost(e) }, { children: _jsxs("span", { children: [_jsx("p", Object.assign({ className: "txt-round" }, { children: "New" })), t("REPORT.신규리포트발행")] }) })) }))) })), _jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "search" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", Object.assign({ className: "flex-row center gap-24" }, { children: [_jsx("span", Object.assign({ className: "wmin-64" }, { children: _jsx("strong", { children: t("라벨.조회기간") }) })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "searchterm gap-8" }, { children: [_jsxs("div", Object.assign({ className: "select term__month", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected w100" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !reloadspg ? dateTermList[4].dtDisp : t("라벨.직접입력") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: dateTermList.map((dt, idx) => (_jsx("li", Object.assign({ id: "date_" + dt.id, className: "option", onClick: () => handleDayPop(dt) }, { children: dt.dtDisp }), `dt_${idx.toString()}`))) })] })), dateSel == 0 && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "term__date" }, { children: [_jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate ? endDate : new Date(), withPortal: isMobile ? true : false, onChange: (date) => setStartDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false }), _jsx("span", Object.assign({ className: "centerline" }, { children: "~" })), _jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, maxDate: new Date(), withPortal: isMobile ? true : false, onChange: (date) => setEndDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false })] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray ml-8", onClick: () => onClickSearchFilter() }, { children: _jsx("span", { children: t("라벨.조회") }) }))] })), dateSel != 0 && (_jsxs("span", { children: [dayjs(startDate).format("YYYY-MM-DD"), " ~ ", dayjs(endDate).format("YYYY-MM-DD")] }))] })) }))] })) })) })) })), _jsx("div", Object.assign({ className: "right ml-auto" }, { children: _jsxs("div", Object.assign({ className: "btn__wrap" }, { children: [_jsxs("div", Object.assign({ className: "searcharea m-none end" }, { children: [_jsx("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.레포트명입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })), _jsxs("div", Object.assign({ className: "flex-row center gap-8 m-none" }, { children: [_jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn btn-share-bg ml-0 tooltip-link white op-1", "data-pop": "pop-share", onClick: (e) => CUTIL.jsopen_Popup(e), "data-tooltip": "\uACF5\uC720" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.공유") })) })), userInfo.role == CONST.USERROLE_ADMIN && (_jsx("button", Object.assign({ type: "button", disabled: checkItem.length <= 0 ? true : false, className: "btn btn-delete-bg ml-0 js-open tooltip-link white op-1", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e), "data-tooltip": "\uC0AD\uC81C" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.삭제") })) }))), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn btn-filedown ml-0 tooltip-link white op-1 w140p", onClick: (e) => handleZipDownload(e), "data-tooltip": "\uB2E4\uC6B4\uB85C\uB4DC" }, { children: _jsxs("span", Object.assign({ className: "hide" }, { children: ["PDF ", t("라벨.다운로드")] })) }))] })), _jsxs("div", Object.assign({ className: "flex-row center gap-8 m-none" }, { children: [_jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-report", onClick: (e) => PdfBasket(e) }, { children: _jsx("span", { children: t("라벨.종합레포트담기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-sky btn-more", "data-pop": "pop-report", onClick: (e) => PopReport(e) }, { children: _jsxs("span", { children: [basketsItem && basketsItem.content.length > 0 ? basketsItem && basketsItem.content.length : "0", " ", _jsx("span", Object.assign({ className: "txt-black fontMedium" }, { children: t("라벨.담음") }))] }) }))] })), _jsxs("div", Object.assign({ className: "m-flex gap-8" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-blue js-open", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic btn-share-bg tooltip-link white op-1", "data-pop": "pop-share", onClick: (e) => CUTIL.jsopen_Popup(e), "data-tooltip": "\uACF5\uC720" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.공유") })) })), userInfo.role == CONST.USERROLE_ADMIN && (_jsx("button", Object.assign({ type: "button", disabled: checkItem.length <= 0 ? true : false, className: "btn-basic btn-delete-bg js-open tooltip-link white op-1", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e), "data-tooltip": "\uC0AD\uC81C" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.삭제") })) }))), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic btn-filedown tooltip-link white op-1 w140p", onClick: (e) => handleZipDownload(e), "data-tooltip": "\uB2E4\uC6B4\uB85C\uB4DC" }, { children: _jsxs("span", Object.assign({ className: "hide" }, { children: ["PDF ", t("라벨.다운로드")] })) }))] })), _jsxs("div", Object.assign({ className: "flex-row center gap-8 m-flex" }, { children: [_jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-report", onClick: (e) => PdfBasket(e) }, { children: _jsx("span", { children: t("라벨.종합레포트담기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-sky btn-more", "data-pop": "pop-report", onClick: (e) => PopReport(e) }, { children: _jsxs("span", { children: [basketsItem && basketsItem.content.length > 0 ? basketsItem && basketsItem.content.length : "0", " ", _jsx("span", Object.assign({ className: "txt-black fontMedium" }, { children: t("라벨.담음") }))] }) }))] }))] })) }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("REPORT.NODATA") })), recoilTreeData.zoneId && (_jsx(ReportList, { recoilTreeData: recoilTreeData, isMobile: isMobile, sortData: sortData, setSortData: setSortData, searchCount: searchCount, searchTextField: searchTextField, startDate: startDate, endDate: endDate, dateTermList: dateTermList, pageInfo: pageInfo, setPageInfo: setPageInfo, handleCurPage: handleCurPage, reportItem: reportItem, setReportItem: setReportItem, checkItem: checkItem, setCheckArr: setCheckArr, checkArr: checkArr, setCheckItem: setCheckItem, averageToogle: averageToogle, setAverageToogle: setAverageToogle, treeSel: treeSel, curTree: curTree, type: type }))] }))] })) }));
}
export default ReportEnergy;
function ReportList(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reloadspg = useRecoilValue(reloadSpg);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    //props
    const { recoilTreeData, isMobile, sortData, setSortData, searchCount, searchTextField, pageInfo, setPageInfo, handleCurPage, reportItem, setReportItem, checkItem, setCheckArr, checkArr, setCheckItem, averageToogle, setAverageToogle, treeSel, type, } = props;
    const [energyInfo, setEnergyInfo] = useState(null);
    let appPath = `zoneId=${recoilTreeData.zoneId}&langId=${langIds}&energyType=${treeSel.code}`;
    appPath = appPath + `&type=${type.code}`;
    appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // 조회 기간
    if (!CUTIL.isnull(searchCount.startDate) && !CUTIL.isnull(searchCount.endDate)) {
        appPath =
            appPath +
                `&startDate=${dayjs(searchCount.startDate).format("YYYYMMDD")}` +
                `&endDate=${dayjs(searchCount.endDate).format("YYYYMMDD")}`;
    }
    // 검색 필드
    if (searchTextField.length > 0) {
        appPath = appPath + `&search=${searchTextField}`;
    }
    // 기기목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyreport/reports?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadspg + pageInfo + langIds,
    });
    useEffect(() => {
        if (data) {
            setRecoilIsLoadingBox(true);
            if (data.codeNum == CONST.API_200) {
                setReportItem(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
            }
            setRecoilIsLoadingBox(false);
        }
        else {
            // alert(data.errorList.map((err) => (err.msg)));
        }
        // };
    }, [data, reloadspg, isMobile, langIds]);
    // 정렬 버튼 액션
    function onClickSort(e, sort) {
        if (e.target.nodeName !== "P") {
            // list 수정
            handleCurPage(0);
            const sortVal = {
                field: sort,
                data: sortData,
                setData: setSortData,
            };
            CUTIL.onClickSort(sortVal);
        }
    }
    function CheckedAll(checked) {
        if (checked) {
            const checks = checkItem.concat(reportItem.filter((checks) => checks.reportId));
            var unique = checks.filter((item, pos) => checks.indexOf(item) === pos);
            const checksId = checkArr.concat(reportItem.filter((checks) => checks.reportId).map((item) => item.energyReportId));
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckArr(uniqueId);
            setCheckItem(unique);
        }
        else {
            let reportItemId = reportItem.map((item) => item.energyReportId);
            setCheckItem(checkItem.filter((item) => !reportItemId.includes(item.energyReportId)));
            setCheckArr(checkArr.filter((item) => !reportItemId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        if (checked) {
            setCheckItem([...checkItem, list]);
            setCheckArr([...checkArr, list.energyReportId]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el.energyReportId !== list.energyReportId));
            setCheckArr(checkArr.filter((el) => el !== list.energyReportId));
        }
    }
    // 평가 점수 토글
    function 평균점수Info(e) {
        if (averageToogle) {
            setAverageToogle(false);
        }
        else {
            setAverageToogle(true);
        }
    }
    function ReportView(item) {
        setEnergyInfo(item);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uADF8\uB8F9,\uC810\uAC80\uD56D\uBAA9,\uCE21\uC815\uC7A5\uBE44,\uC785\uB825\uBC29\uC2DD,\uAC00\uC911\uCE58,\uC810\uAC80\uAC00\uC774\uB4DC,\uCF54\uB4DC,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8  \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "sm-none" }, { children: [_jsx("col", { style: { width: "3%" } }), _jsx("col", { style: { width: "61%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "16%" } }), _jsx("col", { style: { width: "10%" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: `txt-center w6p` }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkArr.length === 0
                                                    ? false
                                                    : reportItem.filter((checks) => checks.reportId).length ==
                                                        reportItem.filter((list) => checkArr.includes(list.energyReportId)).length
                                                        ? true
                                                        : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "reportName" && sortData.sort === "desc" ? "desc" : "asc"} w61p sm-w45p`, onClick: (e) => onClickSort(e, "reportName") }, { children: _jsx("span", { children: t("라벨.레포트명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "updatedTime" && sortData.sort === "desc" ? "desc" : "asc"} ${treeSel.code > 0 ? "d-sm-w76" : ""}`, onClick: (e) => onClickSort(e, "updatedTime") }, { children: _jsx("span", { children: t("라벨.발행일자") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "period" && sortData.sort === "desc" ? "desc" : "asc"} sm-none`, onClick: (e) => onClickSort(e, "period") }, { children: _jsx("span", { children: t("라벨.분석기간") }) })), _jsxs("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "score" && sortData.sort === "desc" ? "desc" : "asc"} ${treeSel.code > 0 ? "d-sm-w60" : ""}`, onClick: (e) => onClickSort(e, "score") }, { children: [_jsxs("div", Object.assign({ className: "tooltip-wrap m-none" }, { children: [_jsx("p", { className: `tooltip-link right-m-90 ${averageToogle ? "click" : ""}`, onClick: (e) => 평균점수Info(e), "data-tooltip": averageToogle ? t("툴팁.평가점수") : "" }), _jsx("span", { children: t("라벨.평가점수") })] })), _jsx("div", Object.assign({ className: "tooltip-wrap m-block" }, { children: _jsx("span", { children: t("라벨.점수") }) }))] }))] }) }), _jsx("tbody", { children: reportItem.length > 0 &&
                                reportItem.map((list, idx) => (_jsxs("tr", Object.assign({ className: energyInfo && energyInfo.energyReportId == list.energyReportId ? "selected" : "" }, { children: [_jsxs("td", Object.assign({ className: "txt-center" }, { children: [_jsx("input", { type: "checkbox", id: "st_" + idx, checked: checkArr.includes(list.energyReportId) ? true : false, onChange: (e) => CheckedList(e.target.checked, list), style: { display: "none" }, disabled: list.reportId ? false : true }), _jsx("label", Object.assign({ htmlFor: "st_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: _jsxs("p", Object.assign({ className: "ellipsis" }, { children: [treeSel.code > 0 && _jsx("span", Object.assign({ className: "badge m-none" }, { children: "Premium" })), list.reportName] })) })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: dayjs(list.updatedTime).format("YYYY-MM-DD") })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list), className: "sm-none" }, { children: list.period })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: `score-level ${list.alarmStatus == "SAFETY" ? "safety" : list.alarmStatus == "WARNING_SCORE" ? "danger" : ""}` }, { children: list.score !== null ? list.score : "-" })) }))] }), "reportList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "ENEGYREPORT", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] }));
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchFieldList, searchText, setSearchText, setSearchTextField } = props;
    const [searchBoolean, setSearchBoolean] = useState(false);
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        setSearchBoolean(true);
    }
    // 진입 시 초기화 이벤트
    useEffect(() => {
        setSearchBoolean(false);
    }, [searchBoolean]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        setSearchTextField(searchText);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
function SharePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTreeData = useRecoilValue(curReportState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { checkItem, repop } = props;
    const [toMails, setToMails] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (repop) {
            shareClose("pop-share");
        }
    }, [repop]);
    function shareClose(id) {
        CUTIL.jsclose_Popup(id);
        setToMails("");
        setErrorList([]);
    }
    function handleSetUserId(e) {
        setErrorList([]);
        setToMails(e.target.value);
    }
    // PDF다운로드
    function handleZipDownload(e) {
        let zipList = [];
        let zips = new JSZip();
        let zipCnt = 0;
        const zipFileName = `${t("REPORT.에너지")}_${recoilTreeData.name}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
        setRecoilIsLoadingBox(true);
        checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
            yield getSecondFileUrl(list)
                .then((val) => {
                if (val.codeNum === 200) {
                    zipList = zipList.concat({
                        fileName: `${t("REPORT.에너지")}_${list.reportName}_${dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss")}.PDF`,
                        fileLink: val.body.fileLink,
                    });
                }
                return {
                    codeNum: val.codeNum,
                    fileName: `${t("REPORT.에너지")}_${list.reportName}_${dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss")}.PDF`,
                    fileLink: val.body.fileLink,
                };
            })
                .then((val) => {
                if (val.codeNum === 200) {
                    axios({
                        method: "GET",
                        url: val.fileLink,
                        responseType: "blob",
                    })
                        .then((resp) => {
                        zips.file(val.fileName, resp.data);
                        zipCnt++;
                        return zipCnt;
                    })
                        .then((zipCnt) => {
                        if (zipCnt === checkItem.length) {
                            zips.generateAsync({ type: "blob" }).then(function (blob) {
                                const email = { email: toMails };
                                linkShare(zipFileName, email, blob); // 공유 연결시 해당 부분 변경
                            });
                        }
                    });
                }
            });
        }));
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function linkShare(zipFileName, email, content) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(email)], { type: "application/json" });
            formData.append("email", blob);
            formData.append("file", content, zipFileName);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/assessment/report/zip/email`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    shareClose("pop-share");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setToMails("");
                }
                else {
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList == null ? CONST.ERROR_MSG : data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input w85p" }, { children: _jsxs("li", Object.assign({ className: "center" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "E-Mail" })), _jsxs("div", Object.assign({ className: "input__area w260" }, { children: [_jsx("input", { type: "text", id: "userId0", placeholder: "공유하실 이메일주소를 입력하세요.", className: errorList.filter((err) => err.field === "email").length > 0 ||
                                            errorList.filter((err) => err.field === "mail").length > 0
                                            ? "input-error"
                                            : "", value: toMails, onChange: (e) => handleSetUserId(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "email").length > 0
                                            ? errorList.filter((err) => err.field === "email").map((err) => err.msg)
                                            : errorList.filter((err) => err.field === "mail").length > 0 &&
                                                errorList.filter((err) => err.field === "mail").map((err) => err.msg) }))] }))] })) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => shareClose("pop-share") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => handleZipDownload(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [reloadspg, setReloadspg] = useRecoilState(reloadSpg);
    const [alert, setAlert] = useRecoilState(alertState);
    //props
    const { checkItem, setCheckItem, setCheckArr, handleCurPage } = props;
    function SheetDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            let success = [];
            let fail = [];
            for (let i = 0; i < checkItem.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/report?reportId=${checkItem[i].reportId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                if (success.length > 0) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setReloadspg(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: t("라벨.삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setCheckArr([]);
                    setCheckItem([]);
                    handleCurPage(0);
                }
                else {
                    // need error handle
                    if (data.errorList.field((err) => err.field == "itemId").length > 0) {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "삭제를 실패했습니다", callBack: () => {
                                CUTIL.jsclose_AlertErrorPopup(CONST.POP_ALERT);
                            } }));
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "500 Internal Server Error", callBack: () => {
                                CUTIL.jsclose_AlertErrorPopup(CONST.POP_ALERT);
                            } }));
                    }
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC120\uD0DD\uD55C \uB808\uD3EC\uD2B8\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SheetDelete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
